var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 161,
    viewBox: "0 0 206 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M143.13 137.079C126.696 149.767 107.229 158.034 86.8135 161L82.4838 131.2C97.7822 128.976 112.382 122.772 124.708 113.257C137.049 103.725 146.748 91.1579 152.769 76.9043L180.51 88.6203C172.478 107.637 159.553 124.394 143.13 137.077V137.079Z",
    fill: "#0073C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M164.046 0.00182674C171.229 0.00182674 178.517 1.96625 185.248 5.88608C198.356 13.519 206.034 26.7695 205.783 41.3351L205.524 56.492L175.415 55.975L175.675 40.8181C175.736 37.2556 173.703 34.0087 170.095 31.9083C166.431 29.7751 162.62 29.561 159.64 31.3187L159.134 31.6108C155.616 33.597 153.429 37.3264 153.427 41.3441L153.42 56.2399L123.306 56.2254L123.313 41.3296C123.32 26.501 131.343 12.7535 144.254 5.42901L144.396 5.34736C150.465 1.78124 157.205 0 164.042 0L164.046 0.00182674Z",
    fill: "#1F9FFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.7401 0.00182674C47.9232 0.00182674 55.2113 1.96625 61.9427 5.88608C75.0499 13.519 82.7281 26.7695 82.4778 41.3351L82.2184 56.492L52.1095 55.975L52.3689 40.8181C52.4306 37.2556 50.3973 34.0087 46.7894 31.9083C43.1253 29.7751 39.3144 29.561 36.3342 31.3187L35.8281 31.6108C32.311 33.597 30.1234 37.3264 30.1216 41.3441L30.1143 56.2399L0 56.2254L0.00719624 41.3296C0.0144518 26.501 8.03739 12.7535 20.9487 5.42901L21.0902 5.34736C27.1595 1.78124 33.8999 0 40.7365 0L40.7401 0.00182674Z",
    fill: "#1F9FFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileFace);
export default __webpack_public_path__ + "static/media/smile-face.4655dfd41fe58dab8e6f3f58533c5177.svg";
export { ForwardRef as ReactComponent };